import { FC } from 'react';
import cn from 'classnames';

import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	page: number;
	onChange: (page: number) => void;
	total?: number;
	pageSize?: number;
	onPageCount?: number;
	textInFilters?: boolean;
}

function formatNumberWithCommas(number: number, textInFilters?: boolean) {
	if (textInFilters) return 'more than 3,000';
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const Pagination: FC<Props> = ({ page, onChange, pageSize = 20, total, onPageCount, textInFilters }: Props) => {
	const handlePrevPage = () => {
		onChange(page - 1);
	};

	const handleNextPage = () => {
		onChange(page + 1);
	};

	return (
		<div className={styles.pagination}>
			{!!total && (
				<Text variant="inter/14/semi">
					{page * pageSize + 1}-{Math.min((page + 1) * pageSize, total)}
				</Text>
			)}
			{!total && onPageCount && (
				<Text variant="inter/14/semi">
					{page * pageSize + 1}-{Math.min((page + 1) * pageSize, page * pageSize + onPageCount)}
				</Text>
			)}
			{total && (
				<Text variant="inter/14/regular" color="dark_grey">
					out of {formatNumberWithCommas(total, textInFilters)}
				</Text>
			)}
			<div className={styles.paginationButtons}>
				<button
					disabled={page === 0}
					onClick={handlePrevPage}
					className={cn(styles.paginationButton, styles.paginationPrevious)}>
					<Icon icon="chevron" />
				</button>
				{!!total && (
					<button
						disabled={total <= (page + 1) * pageSize}
						onClick={handleNextPage}
						className={cn(styles.paginationButton, styles.paginationNext)}>
						<Icon icon="chevron" />
					</button>
				)}
				{!total && onPageCount && (
					<button
						disabled={(page + 1) * pageSize > page * pageSize + onPageCount}
						onClick={handleNextPage}
						className={cn(styles.paginationButton, styles.paginationNext)}>
						<Icon icon="chevron" />
					</button>
				)}
			</div>
		</div>
	);
};
